import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { QueryOptions } from '@app/model/query-options';
import { NgxSpinnerService } from 'ngx-spinner';
import { SourceAddEditService } from './agency-modal/source-add.service';

@Component({
  selector: 'app-agency-add-edit',
  templateUrl: './agency-add-edit.component.html',
  styleUrls: ['./agency-add-edit.component.css'],
  providers : [SourceAddEditService]
})
export class AgencyAddEditComponent implements OnInit {

  sourceNameOptions : any ;
  sourceTypeOptions : any;
  display : boolean = false;
  isEditable : boolean = false;
  source : any = {
    selectedSource : {
          id : '',
          name : '',
          isActive : false
    },

    selectedSourceType : {
      id : '',
      name : ''
    },

    
  };
  
  constructor(
    private _route : Router,
    private _commonService : SourceAddEditService,
    private _spinnerService : NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getSourceTypes();
  }

  redirectToDashboard()
  {
    this._route.navigate(['/home']);
  }

  updateSource(sourceType){
    this.getSources(sourceType);
    this.source.selectedSource = {
      id : ''
    }
     
  }

  queryParams(sortField){
    const queryParams = new Object();
    queryParams['sortParam'] = { sortField: sortField, sortOrder: 1 };
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap();
    return dropDownSortingQueryOptions;
}

showSourceCreation = function (bool: boolean, isEdit? : boolean) { 
  this.display = bool;
  this.isEditable = isEdit;
}

setSourceData = function (obj: any) {
  this.sourceNameOptions = [];
  this.source.selectedSourceType = obj.selectedSourceType;
  this.updateSource(this.source.selectedSourceType);
  this.source.selectedSource.id = obj.id;
  this.source.selectedSource.name = obj.name;
  this.source.selectedSource.isActive = obj.isActive;
}

getSourceTypes()
{
  this._commonService.getAllSourceTypes(this.queryParams("name")).subscribe(res => {
    let types = res.map(item => {
        return {
            id : item.id,
            name : item.name
        }
    });
    this.sourceTypeOptions = types;
    });
}

getSources(sourceType)
{
  this._spinnerService.show();
  this._commonService.getAllAgencies(this.queryParams("name"), sourceType).subscribe(res => {
    let sources = res.map(item => {
      return {
          id : item.id,
          name : item.sourceName,
          sourceTypeId : item.sourceType.id,
          isActive : !item.deleted
      }
  });
    this.sourceNameOptions = sources;
    this._spinnerService.hide();
  });
}

}
